
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/google-sso-login",
      function () {
        return require("private-next-pages/google-sso-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/google-sso-login"])
      });
    }
  